import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function InstructionsPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Instrucciones</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Responda con sinceridad a cada pregunta. No hay respuestas correctas o incorrectas.
            Lea cada ítem con calma y elija la opción que mejor describa su forma de ser o sentir.
          </p>
          <p className="text-sm text-muted-foreground">
            Puede pausar y reanudar más tarde usando el mismo enlace, siempre que no haya expirado.
          </p>
          <Button onClick={() => navigate(`/c/${token}/test`)}>
            Comenzar evaluación
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
